import type { TFunction } from "i18next";
import { CompletionStatus } from "@utils/completion_status.ts";
import type { AnyTask } from "@/types/task";
import useTranslation from "@hooks/use_translation";

const MINUTE = 60000;
const HOUR = 3600000;
const DAY = 24 * HOUR;

const taskStatusText = (task: AnyTask, t: TFunction): string => {
  if (task.status === CompletionStatus.Complete) {
    return t("progress.complete");
  } else if (task.status === CompletionStatus.AlmostFinished) {
    return t("progress.almostFinished");
  } else if (task.status === CompletionStatus.InProgress) {
    return t("progress.inProgress");
  } else if ("created_at" in task && task.created_at) {
    const createdAt = new Date(task.created_at).getTime();
    const now = new Date().getTime();
    const timeAgo = now - createdAt;

    if (timeAgo < HOUR) {
      return t("progress.minutes_ago", {
        count: Math.max(1, Math.floor(timeAgo / MINUTE)),
      });
    } else if (timeAgo < DAY) {
      return t("progress.hours_ago", {
        count: Math.floor(timeAgo / HOUR),
      });
    } else {
      return t("progress.days_ago", {
        count: Math.floor(timeAgo / DAY),
      });
    }
  } else {
    return t("progress.notStarted");
  }
};

const useTaskStatusText = (task: AnyTask): string => {
  const { t } = useTranslation("user");
  return taskStatusText(task, t);
};

export default useTaskStatusText;
